var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.005,
    height: 12.005,
    viewBox: "0 0 12.005 12.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5895",
    "data-name": "\\uD328\\uC2A4 5895",
    d: "M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0Zm1.25,9.3q-.463.183-.739.278a1.95,1.95,0,0,1-.641.1A1.278,1.278,0,0,1,5,9.4a.884.884,0,0,1-.31-.695,2.523,2.523,0,0,1,.023-.335c.016-.114.041-.242.075-.386l.387-1.366c.034-.131.064-.256.087-.371a1.647,1.647,0,0,0,.035-.322.5.5,0,0,0-.108-.364.612.612,0,0,0-.413-.1,1.084,1.084,0,0,0-.307.046c-.1.032-.195.061-.269.089l.1-.421q.38-.155.727-.265A2.147,2.147,0,0,1,5.681,4.8a1.254,1.254,0,0,1,.86.269.9.9,0,0,1,.3.7q0,.089-.021.314a2.1,2.1,0,0,1-.077.412L6.36,7.857c-.032.109-.059.234-.085.374a1.978,1.978,0,0,0-.037.318.457.457,0,0,0,.121.37.68.68,0,0,0,.42.1A1.219,1.219,0,0,0,7.1,8.969a1.809,1.809,0,0,0,.257-.086ZM7.184,3.775a.918.918,0,0,1-.648.25.928.928,0,0,1-.65-.25.8.8,0,0,1-.271-.606.806.806,0,0,1,.271-.608.921.921,0,0,1,.65-.253.911.911,0,0,1,.648.253.819.819,0,0,1,0,1.214Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthTooltipIcon);
export default __webpack_public_path__ + "static/media/earthTooltip_icon.819b1ac0858d7332f5769de2910d16bd.svg";
export { ForwardRef as ReactComponent };